import { CircularProgress, Tooltip } from '@mui/material'
import { useHistory } from 'react-router-dom'
import { DatasetStatus } from '@components'
import * as css from './styles'
import { getStatusColors } from './utils'

interface Props {
  status: typeof DatasetStatus.PENDING | typeof DatasetStatus.APPROVED
  label: string
}

/**
 * Chip with spinner to show for submissions that are processing
 *
 * @param props React props
 * @param {DatasetStatus | PendingStatus} props.status The status of the submission
 * @param {string} props.label The text to show for current status, e.g. show "Success" for submissions with status of "Complete"
 *
 * @returns
 */
export const ProcessingStatusChip = ({ status, label }: Props) => {
  const { location } = useHistory()
  const onDetailsPage = location.pathname.includes('codes/details')
  const { color, backgroundColor } = getStatusColors(status)

  return (
    <Tooltip placement="right" title={onDetailsPage ? '' : label}>
      <css.StyledChip
        data-test-id="status-chip"
        size="small"
        label={label}
        icon={<CircularProgress disableShrink size={12} css={css.progress} />}
        backgroundcolor={backgroundColor}
        fontcolor={color}
      />
    </Tooltip>
  )
}
